import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
} from '@mui/material';

import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function InputPathField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  inputType,
  inputUri,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    const valid = THIRD_PARTY_TYPES.REGIONAL.uriTest.test(newValue);
    setError(!valid);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Datastore path'
          id='input_path'
          aria-describedby='input-path-helper-text'
          variant='outlined'
          fullWidth
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={!inputType || !inputUri || edit}
        />
        {error ? (
          <FormHelperText id='input-path-helper-text'>
            Datastore Path Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='input-path-helper-text'>
            Enter the path within the datastore
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

